module.exports = __webpack_public_path__ + "/298c748e39de28782795f4002325a638.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/assets/megaphone.svg
 ** module id = 1111
 ** module chunks = 0
 **/